import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AssessmentAPI } from '../utils/api';
import { AssessmentResult } from '../types/assessment';
import ResultsView from './ResultsView';

export const ResultsPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [assessmentResult, setAssessmentResult] = useState<AssessmentResult | null>(null);
  const [resultUrl, setResultUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Neplatný odkaz k výsledkům.');
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const data = await AssessmentAPI.getResultByToken(token);
        setAssessmentResult(data.result);
        setResultUrl(data.result_url || window.location.href);
      } catch {
        setError('Výsledky nebyly nalezeny nebo jejich platnost vypršela.');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  if (loading) {
    return (
      <div className="result-page">
        <div className="result-card" style={{ textAlign: 'center' }}>
          <p>Načítám tvoje vyhodnocení...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="result-page">
        <div className="result-card" style={{ textAlign: 'center' }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <ResultsView
      assessmentResult={assessmentResult}
      resultUrl={resultUrl}
      showFollowUp={false}
    />
  );
};

export default ResultsPage;
